import React, { useEffect, useState } from "react";
import api from "../../../../utils/api";
import "./AdminAdmissions.css";

const AdminAdmissions = () => {
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAdmissions = async () => {
    try {
      const res = await api.get("/admissions/all");
      setAdmissions(res.data); // ✅ backend returns array directly
    } catch (err) {
      console.error("Failed to fetch admissions", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmissions();
  }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/admissions/update/${id}`, { status });
      fetchAdmissions();
    } catch {
      alert("Failed to update admission status");
    }
  };

  if (loading) return <p>Loading admissions...</p>;

  return (
    <div className="admission-container">
      <h2 className="admin-dashboard-sec-head">🎓 Manage Admissions</h2>

      <div className="admission-list">
        {admissions.length === 0 ? (
          <p className="empty">No admission applications found</p>
        ) : (
          admissions.map((a) => (
            <div key={a._id} className="admission-card">
              <div className="admission-header">
                <h3>{a.name}</h3>
                <span className={`badge ${a.status}`}>
                  {a.status}
                </span>
              </div>

              <div className="admission-details">
                <p><strong>Email:</strong> {a.email}</p>
                <p><strong>Phone:</strong> {a.phone}</p>
                <p><strong>DOB:</strong> {a.dob}</p>
                <p><strong>Address:</strong> {a.address}</p>
                <p><strong>Course:</strong> {a.course}</p>
                <p><strong>Year:</strong> {a.year}</p>
              </div>

              <div className="meta">
                <span>
                  Applied on: {new Date(a.createdAt).toLocaleDateString()}
                </span>
              </div>

              <div className="actions">
                <button
                  onClick={() => updateStatus(a._id, "approved")}
                  className="success"
                  disabled={a.status === "approved"}
                >
                  Approve
                </button>

                <button
                  onClick={() => updateStatus(a._id, "rejected")}
                  className="warning"
                  disabled={a.status === "rejected"}
                >
                  Reject
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminAdmissions;
